import http from 'services/http-service';

const ReportService = {
    GetDashboard() {
        var response = http.get("/reports/dashboard");
        return response;
    },

    GetDashboardChartDaily() {
        var response = http.get("/reports/dashboardChartDaily");
        return response;
    },

    GetDashboardChartMonthly() {
        var response = http.get("/reports/dashboardChartMonthly");
        return response;
    },


    DownloadSalesReportExcel(status: number, startDate: any, endDate: any) {
        var downloadLink = "/reports/excelSalesReport?status=" + status + "&startDate=" + startDate + "&endDate=" + endDate;
        let result = http.get(downloadLink, { responseType: 'blob', timeout: 300000 });
        return result;
    }
};

export default ReportService;